import { getAppEnvironment } from '../config/runtimeConfig';

// Identity PermissionCatalog.cs ile birebir aynı olmalı
export const LMS = {
    TRAINING_VIEW: 'lms.training.view',
    TRAINING_CREATE: 'lms.training.create',
    TRAINING_UPDATE: 'lms.training.update',
    TRAINING_DELETE: 'lms.training.delete',
    REQUEST_VIEW: 'lms.request.view',
    REQUEST_CREATE: 'lms.request.create',
    REQUEST_UPDATE: 'lms.request.update',
    REQUEST_DELETE: 'lms.request.delete',
    REQUEST_APPROVE: 'lms.request.approve',
    REPORT_VIEW: 'lms.report.view',
    REPORT_CREATE: 'lms.report.create',
    REPORT_UPDATE: 'lms.report.update',
    REPORT_DELETE: 'lms.report.delete',
    DEFINITION_VIEW: 'lms.definition.view',
    DEFINITION_CREATE: 'lms.definition.create',
    DEFINITION_UPDATE: 'lms.definition.update',
    DEFINITION_DELETE: 'lms.definition.delete',
    NEWS_VIEW: 'lms.news.view',
    NEWS_CREATE: 'lms.news.create',
    NEWS_UPDATE: 'lms.news.update',
    NEWS_DELETE: 'lms.news.delete'
};

// BE'de LMS ortak okuma uçları bu kodlardan birini kabul eder
export const LMS_ANY_VIEW = [LMS.TRAINING_VIEW, LMS.REQUEST_VIEW, LMS.REPORT_VIEW, LMS.DEFINITION_VIEW];

// Eğitim içerik yönetimi (eşleştirme, video, doküman): ekle/düzenle/sil yetkilerinden biri
export const LMS_TRAINING_MANAGE = [LMS.TRAINING_CREATE, LMS.TRAINING_UPDATE, LMS.TRAINING_DELETE];

// LMS geliştirme ortamları: yetki kodu VEYA eski kural (Admin). Pilot bitince orLegacy kaldırılır.
export const LMS_LEGACY_RULE = { requiresAdmin: true, excludeRoles: ['WarrantyManager', 'RegionalManager', 'SSHGeneralManager', 'CEO'] };

// LMS canlıda henüz kullanıcılara açık değil: sadece süper admin (ManagerRoleClaim 'UpdateRole') girer.
// Bu kural token'daki manageRoles ile çalışır, BE'de /v1/permission/* uçları olmasa da geçerlidir.
export const LMS_PROD_RULE = { requiresManagePermission: 'UpdateRole' };

// Ortam bilinmiyorsa canlı kuralı uygulanır (güvenli taraf)
const LMS_OPEN_ENVIRONMENTS = ['local', 'dev', 'test'];
export const isLmsOpenEnvironment = () => LMS_OPEN_ENVIRONMENTS.includes(getAppEnvironment());

export const lmsAccess = (codes) => (isLmsOpenEnvironment() ? { anyPermission: codes, orLegacy: LMS_LEGACY_RULE } : LMS_PROD_RULE);
